import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { partnerPortalAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';

const METRICS = [
  ['cadastrados', 'Cadastrados', 'bg-slate-400'], ['indicados', 'Indicados', 'bg-amber-500'], ['chamados', 'Chamados', 'bg-cyan-500'],
  ['entrevistados', 'Entrevistados', 'bg-violet-500'], ['contratados', 'Contratados', 'bg-green-600'],
];
const monthLabel = (k) => {
  const s = new Date(`${k}-15T12:00:00`).toLocaleDateString('pt-BR', { month: 'short', year: '2-digit' });
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const PartnerReportTab = () => {
  const [data, setData] = useState(null);
  useEffect(() => { partnerPortalAPI.report().then((r) => setData(r.data)).catch(() => toast.error('Erro ao carregar relatório')); }, []);

  if (!data) return <Loader2 className="w-6 h-6 animate-spin text-amber-500 mx-auto" />;
  const max = Math.max(1, ...data.meses.flatMap((m) => METRICS.map(([k]) => m[k])));
  return (
    <Card data-testid="partner-report-tab">
      <CardHeader>
        <CardTitle>Relatório Mensal</CardTitle>
        <CardDescription>Últimos 12 meses. Chamados = contatos e cartas de encaminhamento das empresas; entrevistados pela data da entrevista; contratados pelo retorno da empresa.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {METRICS.map(([k, l, c]) => (
            <div key={k} className="rounded-lg border p-3" data-testid={`report-total-${k}`}>
              <div className="flex items-center gap-2 text-xs text-slate-500"><span className={`w-2.5 h-2.5 rounded-sm ${c}`} />{l}</div>
              <div className="text-2xl font-bold">{data.totais[k]}</div>
            </div>
          ))}
        </div>
        <div className="flex items-end gap-3 h-48 overflow-x-auto pb-1" data-testid="report-chart">
          {[...data.meses].reverse().map((m) => (
            <div key={m.mes} className="flex flex-col items-center gap-1 min-w-[44px]">
              <div className="flex items-end gap-0.5 h-40">
                {METRICS.map(([k, l, c]) => (
                  <div key={k} title={`${l}: ${m[k]}`} className={`w-1.5 rounded-t ${c}`} style={{ height: `${(m[k] / max) * 100}%`, minHeight: m[k] ? 3 : 0 }} />
                ))}
              </div>
              <span className="text-[10px] text-slate-500">{monthLabel(m.mes)}</span>
            </div>
          ))}
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="report-table">
            <thead><tr className="text-left text-slate-500 border-b"><th className="py-2 pr-3">Mês</th>{METRICS.map(([k, l]) => <th key={k} className="pr-3">{l}</th>)}</tr></thead>
            <tbody>
              {data.meses.map((m) => (
                <tr key={m.mes} className="border-b last:border-0"><td className="py-1.5 pr-3">{monthLabel(m.mes)}</td>{METRICS.map(([k]) => <td key={k} className="pr-3">{m[k]}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
